import { render } from "./MainTGComponent.vue?vue&type=template&id=3ef91ad1&scoped=true"
import script from "./MainTGComponent.vue?vue&type=script&lang=js"
export * from "./MainTGComponent.vue?vue&type=script&lang=js"

import "./MainTGComponent.vue?vue&type=style&index=0&id=3ef91ad1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef91ad1"]])

export default __exports__